import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Module } from 'src/app/interfaces/module.interface';
import { DomSanitizer } from '@angular/platform-browser';
import Player from '@vimeo/player';
@Component({
    selector: 'app-video-module',
    templateUrl: './video-module.component.html',
    styleUrls: ['./video-module.component.scss']
})
export class VideoModuleComponent implements OnInit {
    @Input() videoelement: any;
    @Input() size: string;
    @Input() i: number;
    videourl: any = '';
    dangerousUrl: any;
    trustedUrl: any;
    player: Player;
    hideButton: boolean = false;
    durationTimer = false;
    startVideo: boolean = false;
    videoActive: boolean = false;
    @ViewChild('videoplayer') videoplayer: ElementRef;
    constructor(private sanitizer: DomSanitizer) {
        this.dangerousUrl = 'javascript:alert("Video Harmfull")';
        this.trustedUrl = sanitizer.bypassSecurityTrustUrl(this.dangerousUrl);
    }

    ngOnInit() {
    }

    activeVideo() {
        this.videourl = '';
        this.videoActive = true;
        let autoplay = '';
        if (this.videoelement.play_method === 'autoplay') {
            autoplay = 'autoplay=1';
        } else {
            autoplay = 'autoplay=0';
        }
        this.dangerousUrl = 'https://player.vimeo.com/video/' + this.videoelement.video_id + '?' + autoplay + '&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
        this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousUrl);
        setTimeout(() => {
            this.play();
        }, 1000);
    }

    play() {
        this.player = new Player(this.videoplayer.nativeElement);
        this.player.play();
        this.player.clickPlay = false;
        this.player.clickPause = true;
        this.player.clickReplay = true;
        this.hideButton = true;
        this.startVideo = true;
        setTimeout(() => {
            this.hideButton = false;
        }, 1000);
        this.player.on('timeupdate', function (data) {
            this.videoprogress = (data.percent * 100);

            this.minuteprogress = Math.floor(data.seconds / 60);
            this.minuteprogress = ('0' + this.minuteprogress).slice(-2);
            this.secondprogress = Math.floor(data.seconds) - this.minuteprogress * 60;
            this.secondprogress = ('0' + this.secondprogress).slice(-2);

            this.totalminuteduration = Math.floor(data.duration / 60);
            this.totalminuteduration = ('0' + this.totalminuteduration).slice(-2);
            this.totalsecondduration = Math.floor(data.duration) - this.totalminuteduration * 60;
            this.progresstime = Math.floor(data.duration);
            this.totalsecondduration = ('0' + this.totalsecondduration).slice(-2);
            this.seekbarproggress = (data.seconds / data.duration) * 100;
        });
        this.player.on('ended', function (data) {
            this.clickReplay = false;
            this.clickPlay = true;
            this.onPlayContent.emit();
        });

        if (this.durationTimer == true) {
            this.durationTimer = false;
        }
        setTimeout(() => {
            this.hideButton = true;
        }, 2000);
    }

    pause() {
        this.player.pause();
        this.player.clickPause = false;
        this.player.clickPlay = true;
        this.durationTimer = true;
    }

    replay() {
        this.play();
    }

    onMouseMove(e) {
        if (this.startVideo == true) {
            var j;
            this.hideButton = false;
            clearTimeout(j)
            j = setTimeout(() => {
                this.hideButton = true;
            }, 2500);
        }
    }

    seekOutside(event) {
        const width = document.getElementById('video-item-' + this.i).offsetWidth;
        var pct = Math.floor((event.offsetX / width) * 100);
        let timeVal = (pct * this.player.progresstime) / 100;
        this.player.setCurrentTime(timeVal);
        this.player.play();
        this.player.clickPlay = false;
        this.player.clickPause = true;
        this.player.clickReplay = true;
    }
    
    public onIntersection({ target, visible }: { target: Element; visible: boolean }): void {
        if (this.videoelement.play_method === 'autoplay') {
            if (visible) {
                this.videoActive = true;
                if (!this.player) {
                    this.dangerousUrl = 'https://player.vimeo.com/video/' + this.videoelement.video_id + '?autoplay=1&loop=1&autopause=0&background=1&byline=0&portrait=0&muted=1';
                    this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl(this.dangerousUrl);
                    setTimeout(() => {
                        this.player = new Player(this.videoplayer.nativeElement);
                        this.player.play();
                        this.player.on('timeupdate', function (data) {
                            this.videoprogress = (data.percent * 100);
                        })
                    }, 200);
                } else {
                    this.player.play();
                    this.player.on('timeupdate', function (data) {
                        this.videoprogress = (data.percent * 100);
                    })
                }
            } else {
                if (this.player) {
                    if (this.player.videoprogress > 0) {
                        this.player.pause();
                    }
                }
            }
        }
    }
}
